module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/brands/modals/import-data-modal/import-data-modal.scss
// module id = ./web/modern/components/brands/modals/import-data-modal/import-data-modal.scss
// module chunks = 0